/* eslint-disable no-unused-expressions */
import { minMediaQueryXL } from 'PlugAndPlay/_global/js/screenSize';

export default function _surveyWidget() {
    /**
     * survey selector
     * @const {string}
     */
    const SURVEY_WIDGET = '.survey-widget';
    /**
    /**
     * survey wrapper selector
     * @const {string}
     */
    const SURVEY_WIDGET_WRAPPER = '.survey-widget__wrapper';
    /**
     * collapse button selector
     * @const {string}
     */
    const COLLAPSE_BUTTON = '.survey-widget__collapse-button';
    /**
     * collapse class selector
     * @const {string}
     */
    const COLLAPSE_CLASS = 'hide-survey-widget';
    /**
     * rotate class selector
     * @const {string}
     */
    const ROTATE_CLASS = 'rotate-survey-chevron';

    const initialiseSurveyWidget = () => {
        const widgetWidth = document.querySelector(SURVEY_WIDGET).offsetWidth;
        const translateWidth = `translateX(${widgetWidth}px)`;
        const surveyWidgetWrapper = document.querySelector(
            SURVEY_WIDGET_WRAPPER
        );
        const collapseButton = document.querySelector(COLLAPSE_BUTTON);
        const screenXL = Number(minMediaQueryXL.replace(/\D/g, ''));

        if (window.screen.width < screenXL) {
            surveyWidgetWrapper.style.transform = translateWidth;
            collapseButton.classList.add(ROTATE_CLASS);
        }

        function collapseSurvery() {
            if (surveyWidgetWrapper.style.transform !== translateWidth) {
                surveyWidgetWrapper.style.transform = translateWidth;
                collapseButton.classList.add(ROTATE_CLASS);
            } else {
                surveyWidgetWrapper.style.transform = 'translateX(0)';
                collapseButton.classList.remove(ROTATE_CLASS);
            }
        }

        collapseButton.addEventListener('click', () => {
            collapseSurvery();
        });
    };

    /**
     * @const {boolean}
     */
    const surveyWidgetExists = !!document.querySelector(SURVEY_WIDGET_WRAPPER);

    // If the module exists, do whatever we need to
    if (surveyWidgetExists) {
        initialiseSurveyWidget();
    }
}

// calls the survey widget function
_surveyWidget();
